// extracted by mini-css-extract-plugin
export default {"firstAndLastPointOffsetSpacing":"5px"};